import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

export async function get() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Settings/BackupPolicy", { headers })).data;
}

export async function set(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Settings/BackupPolicy", data, { headers })).data;
}

export async function run() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Settings/RunBackup", null, { headers })).data;
}
